export enum BannerType {
  Info = 'info',
  Warning = 'warning',
}

interface BaseBannerConfig {
  type?: BannerType;
  dismissible?: boolean;
}

export interface BannerMessageConfig extends BaseBannerConfig {
  message: string;
}

export interface BannerHtmlConfig extends BaseBannerConfig {
  html: string;
}

export type BannerConfig = BannerMessageConfig | BannerHtmlConfig;

export type BannerContent = string | BannerConfig;

export function isBannerConfig(value: unknown): value is BannerConfig {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  const hasMessage =
    'message' in value &&
    typeof (value as BannerMessageConfig).message === 'string' &&
    (value as BannerMessageConfig).message.trim().length > 0;
  const hasHtml =
    'html' in value &&
    typeof (value as BannerHtmlConfig).html === 'string' &&
    (value as BannerHtmlConfig).html.trim().length > 0;

  if (!hasMessage && !hasHtml) {
    return false;
  }

  if ('type' in value) {
    return Object.values(BannerType).includes((value as BannerConfig).type as BannerType);
  }

  return true;
}

export function isBannerHtmlConfig(value: BannerConfig): value is BannerHtmlConfig {
  return 'html' in value;
}
